export enum OrderCargoOrderDriverSimulationModel {
  AB = "AB",
  ABA = "ABA",
  SABS = "SABS",
}

export type OrderCargoOrderDriverSimulationSimulation = {
  contractRate: number;
  bonusRate: number | null;
  distance: number;
  totalCost: number;
};

export type OrderCargoOrderDriverSimulationSimulations = {
  ab: OrderCargoOrderDriverSimulationSimulation;
  aba: OrderCargoOrderDriverSimulationSimulation;
  sabs: OrderCargoOrderDriverSimulationSimulation;
};

export type OrderCargoOrderDriverSimulation = {
  contractNotes: string | null;
  driverNotes: string | null;
  model: OrderCargoOrderDriverSimulationModel;
  simulations: OrderCargoOrderDriverSimulationSimulations;
};

export default OrderCargoOrderDriverSimulation;
